<app-nav></app-nav>
<section class="personalAccident" id="section1" *ngIf="!quotesDetailsTable">
  <div class="container">
    <app-click-to-call></app-click-to-call>
    <div class="col">
      <form name="form" #f="ngForm">
        <center>
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/personal-accident/personal-accident-banner.png"
            class="img-responsive main-image">
        </center>
        <center class="sub-title">
          <p>Get Quotes in just 2 clicks</p>
        </center>
        <div class="col sum-container">
          <p class="title">Choose Sum Insured</p>
          <div class="sum-insured-input">
            <div class="form-check-inline" *ngFor="let sum of sumInsured">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="optradio" value={{sum}} [(ngModel)]="sumValue"
                  (ngModelChange)='changeEventInRadioButton($event)'><label>{{sum}}</label>
              </label>
            </div>
          </div>
          <div class="text-center top-gap-sm">
            <button class="btn btn-bordered-blue" (click)="submitSumInsured()">Next</button>
          </div>
        </div>
      </form>
      <div class="col text-center top-gap-lg mb-5">
        <h6 class="mt-2 text-center" style="
        text-align: center!important;
        margin: 0 auto;
        margin-bottom: 15px;font-weight: 600;
    ">INSURERS</h6>
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/ManipalCigna-min.png" class="img-responsive subnission_image1">
      </div>
    </div>
  </div>
  <div class="footer-bar">
    <span><b><u>Fill Info</u></b></span><span class="next-step-icon"></span><span>Quote Page</span><span
      class="next-step-icon"></span><span>Contact Info.</span><span class="next-step-icon"></span><span>Proposal
      Form</span><span class="next-step-icon"></span><span>Pay</span>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="personalAccident-quote-details" id="section2" *ngIf="quotesDetailsTable">
  <span class="back-icon" (click)="backtoFirstScreen()"><img class="img-responsive"
      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/back.svg"></span>
  <table class="quote-details-table">
    <tbody>
      <tr class="first no-border">
        <td class="">
          <div></div>
        </td>
        <td class="">
          <div></div>
        </td>
      </tr>
      <tr class="no-border">
        <td rowspan="3">
          <span><b>Total Premium</b><br><span class="sub-title">(INR, Excluding Taxes)</span></span>
        </td>
        <td>
          <div>
            <div class="insurer-image">
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png"
                class="img-responsive" width="100%" alt="Religare Insurance">
            </div>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td>
          <div>
            <div class="premium-amount">
              <label class="amount-title"><span class="amount">₹{{netPremium}}</span><br><span class="sub-title">Per
                  annum</span></label>
            </div>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td class="">
          <div>
            <div class="btn_row">
              <div class="col">
                <span><a href="javascript:void(0)" class="downloadPDF" (click)="downloadPDF()"></a></span>
              <span><button type="button" class="btn btn-bordered-blue btn-buy sendPdf"
                 (click)="openModal(templateThankYou);sendPDF()">Email</button></span>
                <span><button type="button" class="btn btn-bordered-blue btn-buy" routerLink="/personal-accident-proposal">Buy</button></span>
                <!-- <span *ngIf="!accidentalBlock"><button type="button" class="btn btn-bordered-blue btn-buy"
                    (click)="openModal(templateThankYou);getContactDetails()">Buy</button></span>-->
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr class="first no-border">
        <td class="">
          <div></div>
        </td>
        <td class="">
          <div></div>
        </td>
      </tr>
      <tr class="no-border">
        <td colspan="2" class="blue-strip">
          <div class="blue-strip-content">
            <div>Covers Opted For</div>
          </div>
        </td>
        <td style="display:none;" class=""></td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Sum Insured</span>
          </div>
        </td>
        <td>
          <div>
            <select name="sumInsuredValue" class="form-control quote-dropdown" id="sumInsuredValue"
              [(ngModel)]="sumValue" (ngModelChange)='changeEventInRadioButton($event);submitSumInsured()'>
              <option *ngFor="let sum of sumInsured" value="{{sum}}">{{sum}}</option>
            </select>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Policy Tenure</span>
          </div>
        </td>
        <td>
          <div>
            <span>{{policyTenure}}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>Accidental Death</span>
          </div>
        </td>
        <td class="">
          <div>
            <icon *ngIf="accidentalDeath == true" class="right"></icon>
            <icon *ngIf="accidentalDeath == false" class="cross"></icon>
          </div>
        </td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>Permanent Total Disability</span>
          </div>
        </td>
        <td class="">
          <div>
            <icon *ngIf="permanentTotalDisability == true" class="right"></icon>
            <icon *ngIf="permanentTotalDisability == false" class="cross"></icon>
          </div>
        </td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>Permanent Partial Disability</span>
          </div>
        </td>
        <td class="">
          <div>
            <icon *ngIf="permanentPartialDisability == true" class="right"></icon>
            <icon *ngIf="permanentPartialDisability == false" class="cross"></icon>
          </div>
        </td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>Medical Expenses</span>
          </div>
        </td>
        <td class="">
          <div class="sum-insured-input">
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="medicalRadio" value="Covered"
                  (change)="getMedicalExpensedValue()" [(ngModel)]="medicalRadio"><label>Covered</label>

              </label>
            </div>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="medicalRadio" value="Not Covered"
                  (change)="getMedicalExpensedValue()" [(ngModel)]="medicalRadio"><label>Not Covered</label>
              </label>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="accidentalBlock">
        <td class="">
          <div>
            <span>Accidental Hospitalization</span>
          </div>
        </td>
        <td class="">
          <div id="accidentalHospitalization">{{accidentalHospitalization}}</div>
        </td>
      </tr>
      <tr *ngIf="accidentalBlock">
        <td class="">
          <div>
            <span>Fractures</span>

          </div>
        </td>
        <td class="">
          <div id="fractures">{{fractures}}</div>
        </td>
      </tr>
      <tr class="no-border">
        <td colspan="2" class="blue-strip">
          <div class="blue-strip-content">
            <div>Conditions</div>
          </div>
        </td>
        <td style="display: none;" class=""></td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>No claims history</span>
          </div>
        </td>
        <td class="">
          <div>
            <icon *ngIf="noClaimHistory == true" class="right"></icon>
            <icon *ngIf="noClaimHistory == false" class="cross"></icon>
          </div>
        </td>
      </tr>
      <tr>
        <td class="">
          <div>
            <span>Filled-Up Proposal Form</span>
          </div>
        </td>
        <td class="">
          <div>
            <icon *ngIf="filledUpProposalForm == true" class="right"></icon>
            <icon *ngIf="filledUpProposalForm == false" class="cross"></icon>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td colspan="2">
          <div class="last-border">
            <span>⋆ Minimum Entry Age is 18 and maximum entry age is 70</span><br>
            <span># Sum Assured should be maximum 10 times of annual income</span><br>
            <span>Note : These are indicative prices. Insurance is the subject matter of solicitation.</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <ng-template #templateContactInfo>
    <!-- <div class="modal-header">
        
      </div> -->
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body" id="contactInfoModal">
        <div class="col">
          <span class="modal-title">Contact Info</span>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col sum-container">
          <p class="title mt-4 mendatory">Name</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <input class="form-control" type="text" name="name" id="name" #name="ngModel" [(ngModel)]="contactName" 
              pattern="[a-zA-Z\s]+" maxlength="200" required>
            </div>
          </div>
        </div>
        <div class="col">
          <div *ngIf="name.invalid && name.touched " class="error-message">
            <div *ngIf="name.errors.required">
              Name is required.
            </div>
            <div *ngIf="name.errors.pattern">
              Please enter valid name.
            </div>
          </div>
        </div>
        <div class="col sum-container">
          <p class="title mt-4 mendatory">Mobile No.</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <input class="form-control" type="text" name="mobile" id="mobile" #mobile="ngModel"
                [(ngModel)]="contactMobile" maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
            </div>
          </div>
        </div>
        <div class="col">
            <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
              <div *ngIf="mobile.errors.required">
                Mobile number is required.
              </div>
              <div *ngIf="mobile.errors.minlength && !mobile.errors.pattern">
                Mobile number must be at least 10 digits long.
              </div>
              <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                Invalid mobile number.
              </div>
            </div>
        </div>
        <div class="col sum-container">
          <p class="title mt-4 mendatory">City</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <input type="text" class="form-control city-input" [typeahead]="cityList" (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)"
                [isAnimated]="true" #city="ngModel" name="city" [(ngModel)]="contactCity"
                  placeholder="City" maxlength="50" required />
            </div>
          </div>
        </div>
        <div class="col">
          <div *ngIf="city.invalid && city.touched " class="error-message">
            <div *ngIf="city.errors.required && !noResult">
              City is required.
            </div>
          </div>
          <div *ngIf="noResult" class="error-message">No results found!</div>
        </div>
        <div class="col sum-container">
          <p class="title mt-4 mendatory">E-mail Address</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <input class="form-control" type="text" name="email" id="email" #email="ngModel"
                [(ngModel)]="contactEmail" [email]="true" required>
            </div>
          </div>
        </div>
        <div class="col">
          <div *ngIf="email.invalid && email.touched " class="error-message">
            <div *ngIf="email.errors.required">
              Email Address is required.
            </div>
            <div *ngIf="email.errors.email">
              Please enter correct Email address.
            </div>
          </div>
        </div>
        <div class="col sum-container">
          <p class="title mt-4">Coupon Code (Optional)</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <input class="form-control" type="text" maxlength="50">
            </div>
          </div>
        </div>
        <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close" [disabled]="f.form.invalid || noResult"
            (click)="updateProspect()">Next</button>
        </div>
      </div>
    </form>

  </ng-template>
  <ng-template #templateThankYou>
    <!-- <div class="modal-header">
        
      </div> -->
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body" id="contactInfoModal">
        <div class="col">
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col text-center mt-4">
          <h4 class="modal-title">Thank You</h4>
          <p>We will call you back within 24 hours.</p>
        </div>
      </div>
    </form>

  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>